export default __webpack_public_path__ + "static/media/android.4869a8ff.svg";